import { Flex, Text, Card, Icon } from "@chakra-ui/react";

interface ProjectCardProps {
  width?: any;
  project: {
    title: string;
    description: string;
    icons: any[];
  };
}

export default function ProjectCard({
  width,
  project,
}: ProjectCardProps): JSX.Element {
  return (
    <Card variant={"custom"} width={width}>
      <Text fontSize={"1.2rem"} fontWeight={"bold"}>
        {project.title}
      </Text>
      <Text>{project.description}</Text>
      <Flex justifyContent={"center"} gap={3}>
        {project.icons.map((icon: any, index: number) => (
          <Icon key={`project-icon-${index}`} as={icon} />
        ))}
      </Flex>
    </Card>
  );
}
